import { INITIAL_STATE, setUsers, addUser } from '../core'
import {
    RECEIVE_USER,
    RECEIVE_USERS,
} from '../action_creators'

// This is currently unused
function users(state=INITIAL_STATE.users, action) {
    switch (action.type) {
        case RECEIVE_USERS:
            // handle v1 actions calling "RECEIVE_USERS" with a single user
            if (Array.isArray(action.users)) {
                return setUsers(state, action.users)
            } else {
                return addUser(state, action.users)
            }
        case RECEIVE_USER:
            return addUser(state, action.user)
        default:
            return state
    }
}

export default users


// WEBPACK FOOTER //
// ./src/redux/reducers/users_reducer.js